module.exports = __webpack_public_path__ + "6d4e5108c7a81693d67d03ee4d02ae0f.svg";